export const getBrands = (state) => state.brands
